<template>
  <el-row :gutter="16" style="padding-bottom: 60px" :loading="loading">
    <el-col :lg="13" :md="24" :xl="13">
      <el-card class="card">
        <div class="card-title" slot="header">
          {{ $t('store::album::edit_基本信息') }}
        </div>

        <el-form :label-position="'top'" ref="form" :model="form" :rules="rules">
          <el-form-item :label="$t('store::album::list_店铺')" prop="shopId">
            <el-select
              style="width: 100%"
              :popperAppendToBody="false"
              v-model="form.shopId"
              :placeholder="$t('system::common::select_placeholder')"
              @change="changeShop"
            >
              <el-option v-for="item in shopList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('store::album::list_专辑类型')">
            <el-radio-group v-model="form.dataType" @change="changeType">
              <div class="form-radio">
                <div style="margin-bottom: 24px">
                  <el-radio :label="1">
                    {{ $t('store::album::list_自动') }}
                  </el-radio>
                  <span class="tip">({{ $t('store::album::edit_自动tip') }})</span>
                </div>
                <div>
                  <el-radio :label="2">
                    {{ $t('store::album::list_手动') }}
                  </el-radio>
                  <span class="tip">({{ $t('store::album::edit_手动tip') }})</span>
                </div>
              </div>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('store::album::edit_专辑图片')">
            <pictureUpload v-model="form.collectionImage" folder="album" style="display: inline-block"></pictureUpload>
            <span class="tip" style="vertical-align: bottom; line-height: 1">
              {{ $t('store::album::edit_推荐尺寸') }}：600*1080px
            </span>
          </el-form-item>
          <el-form-item :label="$t('store::album::edit_图片描述')">
            <el-input
              type="textarea"
              :rows="5"
              v-model="form.collectionImageDesc"
              show-word-limit
              :maxlength="320"
              :placeholder="$t('store::album::edit_图片描述tip')"
            ></el-input>
            <span style="color: #999; font-size: 13px">{{ $t('store::album::edit_图片tip') }}</span>
          </el-form-item>
          <el-form-item :label="$t('store::album::edit_标题')" prop="title">
            <el-input v-model="form.title" show-word-limit :maxlength="70"></el-input>
          </el-form-item>
          <el-form-item :label="$t('store::album::edit_专辑描述')">
            <rich-editor v-model="form.collectionDesc" :height="420" />
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>

    <el-col :lg="11" :md="24" :xl="11">
      <el-card class="card">
        <div style="display: flex; justify-content: space-between" slot="header">
          <div class="card-title">
            {{ $t('store::album::edit_商品列表') }}
            <span style="font-size: 12px">
              {{ $t('store::album::edit_已选商品') }}：{{ form.customSortList.length || 0 }}
            </span>
          </div>
          <div v-if="form.dataType === 1">
            <el-button @click="getConditionGoods" :disabled="!form.conditions.length">
              {{ $t('store::album::edit_刷新列表') }}
            </el-button>
            <el-button type="primary" @click="showConditionsDialog = true">
              {{ $t('store::album::edit_设置商品条件') }}
            </el-button>
          </div>
          <el-button v-else type="primary" :disabled="!form.shopId" @click="showAddGoodsDialog = true">
            {{ $t('store::album::edit_添加商品') }}
          </el-button>
        </div>
        <el-input v-model="search" :placeholder="$t('store::album::edit_请输入商品名称或SPU搜索')">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
        <draggable :list="form.customSortList" :disabled="search.length" class="list" v-bind="dragOptions">
          <div class="column-item" v-for="i in showGoodsList" :key="i.spuId">
            <i class="iconfont iconSort drag-icon icon move" title="移动"></i>
            <ZImg class="images" :src="i.spuImg"></ZImg>
            <div class="content">
              <div>{{ i.spuId }}</div>
              <div style="color: #999999; font-size: 12px">{{ i.title }}</div>
            </div>
          </div>
        </draggable>
      </el-card>
    </el-col>

    <el-col :lg="11" :md="24" :xl="11">
      <el-card class="card">
        <div class="card-title" slot="header">
          {{ $t('store::album::edit_商品专辑角标') }}
        </div>
        <div>
          <div class="coner-mark">
            <span>Sale：</span>
            <div class="mark" :class="form.tag === 2 ? 'select' : ''" @click="form.tag = 2">
              <img src="@/assets/images/album/half.png" class="mark-image" />
              <div class="select-icon" v-if="form.tag === 2"><i class="iconfont iconarrow-gouxuan"></i></div>
            </div>
          </div>
          <div class="coner-mark" style="margin-top: 20px">
            <span>New：</span>
            <div class="mark" :class="form.tag === 3 ? 'select' : ''" @click="form.tag = 3">
              <img src="@/assets/images/album/new.png" class="mark-image" />
              <div class="select-icon" v-if="form.tag === 3"><i class="iconfont iconarrow-gouxuan"></i></div>
            </div>
          </div>
        </div>
      </el-card>
      <footer-fixed>
        <el-button size="small" type="default" class="f-btn" @click="$router.go(-1)">
          {{ $t('system::common::btn::cancel') }}
        </el-button>
        <el-button size="small" type="primary" class="f-btn" :loading="sumbitLoading" @click="confirm">
          {{ $t('system::common::btn::confirm') }}
        </el-button>
      </footer-fixed>
    </el-col>
    <addGoods
      v-model="showAddGoodsDialog"
      :goodsList="form.customSortList"
      :shopId="form.shopId"
      @addGoods="addGoods"
    ></addGoods>
    <setCondition v-model="showConditionsDialog" :form="form" @save="setAlbumCondition"></setCondition>
  </el-row>
</template>

<script>
import { getGoodsListByConditions, getAlbumDetail, saveOrUpdateAlbum, getShopList } from '@/server/album'
import pictureUpload from '@/components/common/picture-upload/index'
import RichEditor from '@/components/rich-editor'
import draggable from 'vuedraggable'
import addGoods from './addGoods.vue'
import setCondition from './setCondition.vue'
export default {
  components: {
    pictureUpload,
    RichEditor,
    draggable,
    setCondition,
    addGoods,
  },
  data() {
    return {
      form: {
        shopId: '',
        dataType: 1,
        collectionImage: '',
        collectionImageDesc: '',
        title: '',
        collectionDesc: '',
        conditionType: 1,
        tag: 2,
        conditions: [],
        customSortList: [],
        filterSpuIds: '',
      },
      beforeShopId: null,
      rules: {
        shopId: [{ required: true, message: this.$t('store::album::edit_请选择店铺'), trigger: 'change' }],
        title: [{ required: true, message: this.$t('store::album::edit_请填写标题'), trigger: 'blur' }],
      },
      search: '',
      shopList: [],
      showConditionsDialog: false,
      showAddGoodsDialog: false,
      loading: false,
      sumbitLoading: false,
    }
  },
  computed: {
    dragOptions() {
      return {
        handle: '.drag-icon',
        dragClass: 'drag-item',
        chosenClass: 'chosenClass',
        forceFallback: true,
        animation: 100,
        fallbackOnBody: true,
        swapThreshold: 0.65,
        scrollSensitivity: 100,
        fallbackTolerance: 1,
        bubbleScroll: true,
        scrollSpeed: 2000,
        scroll: true,
        scrollFn: this.sortable(),
      }
    },
    showGoodsList() {
      return this.form.customSortList.filter(el => {
        return el.spuId.toString().includes(this.search) || el.title.includes(this.search)
      })
    },
  },
  mounted() {
    this.getShopList()
  },
  activated() {
    if (this.$route.params.id) {
      this.getAlbumDetail(this.$route.params.id)
    }
  },
  methods: {
    async getShopList() {
      const { data } = await getShopList()
      if (Array.isArray(data.data)) {
        this.shopList = data.data.map(item => {
          return {
            label: item.shopName,
            value: item.shopId,
          }
        })
      }
    },
    async getAlbumDetail(id) {
      this.loading = true
      let data = await getAlbumDetail(id)
      if (data.data.code === this.$code) {
        this.form = { ...this.form, ...data.data.data }
        this.beforeShopId = this.form.shopId
        if (this.$route.name.includes('copy')) {
          delete this.form.id
        }
      }
      this.loading = false
    },
    changeShop() {
      if (this.form.customSortList.length && this.beforeShopId) {
        this.$confirm(
          this.$t('store::album::edit_切换后已有商品列表将被清空！'),
          this.$t('store::album::edit_确认要切换店铺吗？'),
          {
            confirmButtonText: this.$t('system::common::btn::confirm'),
            cancelButtonText: this.$t('system::common::btn::cancel'),
          }
        )
          .then(() => {
            if (this.form.dataType === 1 && this.form.conditions.length) {
              this.getConditionGoods()
            } else if (this.form.dataType === 2) {
              this.form.customSortList = []
            }
          })
          .catch(() => {
            this.form.shopId = this.beforeShopId
          })
      } else {
        if (this.form.dataType === 1 && this.form.conditions.length) {
          this.getConditionGoods()
        }
        this.beforeShopId = this.form.shopId
      }
    },
    changeType() {
      if (this.form.customSortList.length) {
        this.$confirm(
          this.$t('store::album::edit_切换后已有商品列表将被清空！'),
          this.$t('store::album::edit_确认要切换专辑模式吗？'),
          {
            confirmButtonText: this.$t('system::common::btn::confirm'),
            cancelButtonText: this.$t('system::common::btn::cancel'),
          }
        )
          .then(() => {
            this.form.customSortList = []
            this.form.conditions = []
            this.form.filterSpuIds = ''
            this.form.conditionType = 1
          })
          .catch(() => {
            this.form.dataType = this.form.dataType === 1 ? 2 : 1
          })
      }
    },
    sortable() {
      console.log(this.form.customSortList)
    },
    // 设置专辑条件
    setAlbumCondition(val) {
      let { filterSpuIds, conditions, conditionType } = val
      conditions.forEach(el => {
        if (el.filterObj === 2) {
          el.target = el.target[el.target.length - 1]
        }
      })
      this.form = { ...this.form, filterSpuIds, conditions, conditionType }
      this.getConditionGoods()
    },
    // 根据条件获取商品列表
    async getConditionGoods() {
      let { filterSpuIds, conditions, conditionType, shopId } = this.form
      let data = await getGoodsListByConditions({ conditionList: conditions, filterSpuIds, conditionType, shopId })
      if (data.data.code === this.$code) {
        this.form.customSortList = data.data.data.productList
      }
    },
    addGoods(val) {
      this.form.customSortList = val
    },
    confirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (!this.form.customSortList.length) {
            this.$message.error(this.$t('store::album::edit_请添加商品'))
            return
          }
          this.form.customSortList.forEach((el, index) => {
            el.sortIndex = index
          })
          this.save(this.form)
        }
      })
    },
    async save(form) {
      this.sumbitLoading = true
      let data = await saveOrUpdateAlbum(form)
      if (data.data.code === this.$code) {
        this.$message.success(this.$t('system::tip::save_success'))
        this.keepUpdate('/album')
        this.closeCurTab()
        this.$router.push('/album')
      }
      this.sumbitLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-card__header {
  border-bottom: 1px solid #dcdfe6;
}
/deep/.el-radio {
  margin-right: 0;
}
/deep/.el-input-group__append,
.el-input-group__prepend {
  background: #0560fd !important;
  color: #fff;
}
.card-title {
  font-size: 16px;
  font-weight: bold;
}
.card {
  margin-bottom: 16px;
}
.form-radio {
  display: flex;
  flex-direction: column;
}
.tip {
  font-size: 13px;
  color: #999;
  margin-left: 8px;
}
.list {
  margin-top: 15px;
  height: 500px;
  overflow: auto;
  background: #f0f2f5;
  padding: 16px;
}
.column-item {
  background: #ffffff;
  border: 1px solid #dfe3e9;
  display: flex;
  align-items: center;
  padding: 16px;
  .images {
    margin: 0 16px;
    width: 43px;
    height: 43px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
  }
}
.column-item + .column-item {
  margin-top: 12px;
}
.column-item.drag-item {
  opacity: 1 !important;
  cursor: move !important;
  background-color: #fff;
}
.coner-mark {
  display: flex;
  align-items: center;
}
.mark {
  position: relative;
  width: 64px;
  height: 64px;
  border-radius: 6px;
  margin-left: 24px;
  box-sizing: border-box;
  cursor: pointer;
}
.mark-image {
  width: 64px;
  height: 64px;
}
.select {
  border: 1px solid #67c23a;
}
.select-icon {
  width: 20px;
  height: 20px;
  background: #67c23a;
  border-radius: 100px 0px 20px 0px;
  position: absolute;
  bottom: 0;
  right: 0;
  text-align: center;
  line-height: 22px;
  font-size: 12px;
  color: #fff;
}
</style>
